export default (cookie_name: string, cookie_value: any, cookie_expiration_days: number, cookie_path: string, cookie_domain: null | string) => {
    // Delete the cookie on the old path first
    if (cookie_path !== '/') {
        if (cookie_domain !== null) {
            document.cookie = `${cookie_name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=${cookie_path};Domain=${cookie_domain}`;
        } else {
            document.cookie = `${cookie_name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=${cookie_path};`;
        }
    }

    // Set the cookie on the root path
    const date = new Date();
    date.setTime(date.getTime() + (cookie_expiration_days * 24 * 60 * 60 * 1000));
    if (cookie_domain !== null) {
        document.cookie = `${cookie_name}=${cookie_value};expires=${date.toUTCString()};path=/;Domain=${cookie_domain}`;
    } else {
        document.cookie = `${cookie_name}=${cookie_value};expires=${date.toUTCString()};path=/;`;
    }
};